import {
    SET_WOD_DATA,
    SET_WODS_DATA,
    SET_WOD_COUNT,
  } from '../../actions/types/types';
  
  const initState = {
    wod: {},
    wods: [],
    wodCount: 0,
    memberWods:[],
    memberWodPage:1,
    memberWodLimit:10

  };
  
  const WodReducer = (state = initState, action) => {
    switch (action.type) {
      case SET_WOD_DATA:
        return {
          ...state,
          wod: action.payload.data,
        };
      case SET_WOD_COUNT:
        return {
          ...state,
          wodCount: action.payload.data,
        };
      case SET_WODS_DATA:
        return {
          ...state,
          wods: action.payload.data,
        };
      case "SET_MEMBER_WOD":
        return {
          ...state,
          memberWods:action.payload.data
        }  
       case "SET_MEMBER_WOD_LIMIT":
         return {
          ...state,
          memberWodLimit:action.payload.data
        } 
       case "SET_MEMBER_WOD_PAGE":
         return {
          ...state,
          memberWodPage:action.payload.data
        }  
      default:
        return { ...state };
    }
  };
  
  export default WodReducer;
  